// snackbarService.ts
import { AlertColor } from '@mui/material/Alert';

let snackbarRef: ((message: string, severity?: AlertColor) => void) | null = null;

export const snackbarService = {
  register(fn: (message: string, severity?: AlertColor) => void) {
    snackbarRef = fn;
  },
  showSnackbar(message: string, severity: AlertColor = 'info') {
    if (!snackbarRef) {
      console.warn('Snackbar service not registered');
      return;
    }
    snackbarRef(message, severity);
  }
};
